export default "__VITE_ASSET__DDnKa6V$__"